module.exports = __webpack_public_path__ + "static/media/003-plant-pot.5fa16952.svg";